import { Breadcrumbs } from 'components/Breadcrumbs/Breadcrumbs';
import React, { ReactElement } from 'react';
import styles from './titleWithBreadcrumbs.module.scss';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

export const TitleWithBreadcrumbs: React.FC<{
  title: string;
  routes: BreadcrumbsRoute[];
  hint?: ReactElement;
}> = ({ title, routes, hint }) => {
  return (
    <div className={styles.titleWithBreadcrumbs}>
      <div className={styles.title}>
        {title}
        {hint}
      </div>
      <div className={styles.breadcrumbs}>
        <Breadcrumbs routes={routes} />
      </div>
    </div>
  );
};
